// Unified Search Result Component
// Displays search results from all content types (Q&A, Videos, Trivia) in a unified format

import React from 'react';
import './UnifiedSearchResult.css';

export function UnifiedSearchResult({ result, onResultClick }) {
  const getContentTypeInfo = (type) => {
    switch (type) {
      case 'qa':
        return {
          icon: 'fa-solid fa-question-circle',
          label: 'Q&A',
          color: '#ff4444'
        };
      case 'video':
        return {
          icon: 'fa-solid fa-video',
          label: 'Tutorial',
          color: '#4ade80'
        };
      case 'trivia':
        return {
          icon: 'fa-solid fa-brain',
          label: 'Trivia',
          color: '#fbbf24'
        };
      default:
        return {
          icon: 'fa-solid fa-file',
          label: 'Content',
          color: '#6b7280'
        };
    }
  };

  const typeInfo = getContentTypeInfo(result.type);

  // Use the unified data structure from the search endpoint
  const getTitle = () => {
    return result.title || 'Untitled';
  };

  const getSubtitle = () => {
    return result.description || '';
  };

  const getMetaInfo = () => {
    // For now, just show tags if available
    if (result.tags && result.tags.length > 0) {
      return result.tags.slice(0, 3).join(', ');
    }
    return '';
  };

  return (
    <div className="unified-search-result" onClick={() => onResultClick(result)}>
      <div className="result-icon">
        <i className={typeInfo.icon} style={{ color: typeInfo.color }}></i>
      </div>

      <div className="result-content">
        <div className="result-title">{getTitle()}</div>
        <div className="result-subtitle">{getSubtitle()}</div>
        <div className="result-meta">{getMetaInfo()}</div>
      </div>

      <div className="result-arrow">
        <i className="fa-solid fa-chevron-right"></i>
      </div>
    </div>
  );
}